import { CustomAmountInput, CustomDropDown } from "shared/AllInputs";
import { handleChange } from "utils/TableFunctions";
import formValidation from "utils/validations";

export const DropdownEditor = ({ name, options, list, allValues }) => {
    const formErrors = formValidation(name, options.value, allValues);
    return (
        <CustomDropDown
            value={options.value}
            options={list || []}
            col={12}
            onChange={({ value }) => {
                options.editorCallback(value);
            }}
            name={name}
            ignoreLabel
            errorMessage={formErrors[name]}
        />
    );
}

export const NumberEditor = ({ name, options, inputIcon, allValues, ignoreInputs, optional, thanField, maxSize, minSize, setAllValues }) => {
    const formErrors = formValidation(name, options.value, allValues, ignoreInputs, optional, "", thanField, maxSize, minSize);
    return (
        <>
            <CustomAmountInput
                extraClassName="w-full p-0"
                inputClass="m-0"
                value={options.value}
                col={12}
                onChange={({ value }) => {
                    options.editorCallback(value);
                    setAllValues && handleChange(name, value, options.rowIndex, allValues, setAllValues)
                }}
                name={name}
                spanIcon={inputIcon}
                spanExtraClassName={"p-2"}
                ignoreLabel
                errorMessage={formErrors[name]}
            />
        </>

    );
}